import { NativeSelect } from "@/components/ui/native-select";
export function CompareMetricSelect(props: { options: { key: string; label: string }[]; value: string; onChange: (value: string) => void }) {
  return (
    <label className="quiet-chart-header__field">
      <span className="quiet-chart-header__label">Compare with</span>
      <NativeSelect
        aria-label="Compare with"
        className="quiet-chart-header__select"
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)}
      >
        <option value="">None</option>
        {props.options.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </NativeSelect>
    </label>
  );
}
